import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {LoadingStatus} from "../../common-types/loading-status";
import {AuthService} from "@fedelta-pos/data-client";
import {TranslateService} from "ng2-translate";
import {LoadingService} from "../../ui-elements/loading/loading.service";
import {NavigationService} from "../../orchestration/navigation.service";
import {Page} from "../../orchestration/page";
import {OrderingContext} from "../../ordering-context/ordering-context";
import {NotificationService} from "../../notification/notification.service";
import {PromoModel} from "../../promo/promo.model";
import {IdentityModel} from "../../identity/identity.model";
import {DealModel} from "../deal.model";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {IdentificationMode} from "../../identity/identification-page/identification-mode";
import {MenuItemSelection} from "../../menu/menu-events";
import {SessionEvents} from "../../orchestration/session-events";
import {AppPromoAction, AppPromoData} from "../../identity/member-summary-entity.model";
import {DealData, DealResult, DealResultCode} from "../deal-entity.model";
import {MenuItemData} from "../../menu/menu-entity.model";

/**
 * List of all available deals / promotions
 */
@Component({
    selector: "woa-deals-page",
    templateUrl: "./deals-page.component.html",
    providers: [{provide: Page, useExisting: DealsPageComponent}]
})
export class DealsPageComponent extends Page implements OnInit {
    SessionEvents = SessionEvents;

    public LoadingStatus = LoadingStatus;
    public status: LoadingStatus = LoadingStatus.LOADING;
    public allAvailableDeals: DealData[] = [];
    public memberDeals: DealData[] = [];
    public appDeals: DealData[] = [];
    public allUntriggeredCardPromos: AppPromoData[] = [];

    constructor(private orderingContextModel: OrderingContextModel,
                public identityModel: IdentityModel,
                public dealModel: DealModel,
                public navigationService: NavigationService,
                private promoModel: PromoModel,
                private authService: AuthService,
                private translate: TranslateService,
                private loadingService: LoadingService,
                private notificationService: NotificationService,
                private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    get nrDeals(): number {
        return this.allAvailableDeals.length + this.allUntriggeredCardPromos.length;
    }

    ngOnInit(): void {
        this.status = LoadingStatus.LOADING;
        this.loadMemberSummary();
    }

    loadMemberSummary(): void {
        // noinspection JSIgnoredPromiseFromCall
        this.loadingService.performWithSpinner(async () => {
            try {
                await this.identityModel.loadMemberSummary();
                this.status = LoadingStatus.LOADED;
            } catch (error) {
                this.status = LoadingStatus.FAILED;
            }
            this.allAvailableDeals = this.identityModel.currentMember.deals
                .filter((deal: DealData) => !deal.isTicket && deal.isAvailableForOrderType(this.orderingContextModel.orderType));
            this.memberDeals = this.allAvailableDeals
                .filter((deal: DealData) => !deal.isTicket && deal.memberDeal);
            this.appDeals = this.allAvailableDeals
                .filter((deal: DealData) => !deal.isTicket && !deal.memberDeal);
            this.allUntriggeredCardPromos = this.identityModel.currentMember.promos
                .filter((promo: AppPromoData) =>
                    promo.isAvailableForOrderType(this.orderingContextModel.orderType) &&
                    !promo.triggered && promo.showAppPromoCard &&
                    (!promo.promotedSellables.length || this.promoModel.canPromoteSellablesAsCard(promo, false)));
            this.changeDetectorRef.detectChanges();
        });
    }

    async enterDealCode(): Promise<any> {
        const result: DealResult = await this.navigationService.createPage("woa-deal-code-entry-page");
        if (result && (result.resultCode === DealResultCode.IMMEDIATE || result.resultCode === DealResultCode.DEFERRED)) {
            return this.navigationService.dismissPage(this);
        }
    }

    async login(): Promise<void> {
        return this.navigationService.createPage("woa-identification-page", {"mode": IdentificationMode.LOGIN});
    }

    async orderDeal(deal: DealData): Promise<any> {
        const result: DealResult = await this.dealModel.orderDeal(deal);
        if (result.resultCode === DealResultCode.UNAVAILABLE) {
            await this.notificationService.displayAlert(null, result.msg);
        } else if (result.resultCode === DealResultCode.IMMEDIATE || result.resultCode === DealResultCode.DEFERRED) {
            return this.navigationService.dismissPage(this);
        }
    }

    async promoActioned(promo: AppPromoData, menuItem: MenuItemData): Promise<any> {
        if (promo.promoCardAction === AppPromoAction.ORDER_PRODUCT && await this.orderingContextModel.applyOrderingContext(new OrderingContext().withSelectedMenuItem(new MenuItemSelection(menuItem)))) {
            return this.navigationService.dismissPage(this);
        }
        if (promo.promoCardAction === AppPromoAction.SHOW_PRODUCTS) {
            this.promoModel.setActivatedPromo(promo);
            return this.navigationService.dismissPage(this);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/deal/deals-page/deals-page.component.ts